import { useEffect } from "react";
import { useHistory } from "react-router-dom";

const NavigationBlocker = () => {
  const history = useHistory();

  useEffect(() => {
    if (!history) {
      //   console.debug("History object is undefined. Ensure NavigationBlocker is inside a Router.");
      return;
    }

    // console.debug("Setting up navigation blocker");
    // console.debug("Initial history length:", history.length || "N/A");

    // Push multiple history entries to deepen the stack
    for (let i = 0; i < 10; i++) {
      history.push(history.location);
      //   console.debug("Pushed history entry (react-router), length:", history.length);
    }

    // Fallback: Push entries using window.history
    for (let i = 0; i < 10; i++) {
      window.history.pushState(null, document.title, window.location.href);
      //   console.debug("Pushed history entry (window.history), length:", window.history.length);
    }

    // Block navigation with react-router
    const unblock = history.block((location, action) => {
      //   console.debug("Navigation attempt:", action, location);
      if (action === "POP") {
        // console.debug("Blocking back navigation (react-router)");
        for (let i = 0; i < 5; i++) {
          history.push(history.location);
        }
        // console.debug("Pushed blocking entries (react-router), length:", history.length);
        return false;
      }
    });

    // Fallback: Block with window.history popstate
    const handlePopState = (event) => {
      //   console.debug("popstate triggered:", event);
      for (let i = 0; i < 5; i++) {
        window.history.pushState(null, document.title, window.location.href);
      }
      //   console.debug("Pushed blocking entries (window.history), length:", window.history.length);
    };

    window.addEventListener("popstate", handlePopState);

    // Handle swipe gestures
    const preventSwipe = (event) => {
      if (event.type === "touchstart") {
        window.touchStartX = event.touches[0].clientX;
        // console.debug("Touchstart at x:", window.touchStartX);
      } else if (event.type === "touchmove" && window.touchStartX <= 150) {
        // Increased threshold
        // console.debug("Blocking swipe gesture at x:", window.touchStartX);
        event.preventDefault();
      }
    };

    document.addEventListener("touchstart", preventSwipe, { passive: false });
    document.addEventListener("touchmove", preventSwipe, { passive: false });

    // Periodically push history entries to maintain stack
    const interval = setInterval(() => {
      history.push(history.location);
      window.history.pushState(null, document.title, window.location.href);
      //   console.debug("Periodic history push (react-router), length:", history.length);
      //   console.debug("Periodic history push (window.history), length:", window.history.length);
    }, 1000); // Increased frequency

    // Cleanup
    return () => {
      //   console.debug("Cleaning up navigation blocker");
      unblock();
      window.removeEventListener("popstate", handlePopState);
      document.removeEventListener("touchstart", preventSwipe);
      document.removeEventListener("touchmove", preventSwipe);
      clearInterval(interval);
    };
  }, [history]);

  return null;
};

export default NavigationBlocker;
